export default __webpack_public_path__ + "static/media/colors-101.1d74139d.png";